<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-04
      	描述：插件中心-icp
      -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="查询" name="query">
      </el-tab-pane>
      <el-tab-pane label="查询历史" name="history">
      </el-tab-pane>
      <el-tab-pane label="设置" name="setting">
      </el-tab-pane>
    </el-tabs>

    <!--查询页面-->
    <Query v-if="activeName=='query'"></Query>
    <!--历史记录查询页面-->
    <History v-if="activeName=='history'"></History>
    <!--配置页面-->
    <Setting v-if="activeName=='setting'"></Setting>

  </div>
</template>
<script>
  import Query from './icp/index'
  import History from './icp/history'
  import Setting from './icp/setting'

  export default {
    components: {
      Query,
      History,
      Setting
    },
    data() {
      return {
        activeName: 'query',
      };
    },
    created() {},
    methods: {}
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/icp/index.vue